<div class="heading-wrapper">
    <h1>{{ headerKey | vtranslate }}</h1>
    <ng-content></ng-content>
</div>